import cn from '@/utils/cn';
import React, { HTMLAttributes, ReactNode } from 'react';
import { VariantProps } from 'class-variance-authority';
import { toggleVariants } from './toggleVariants';

interface ToggleInputProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof toggleVariants> {
  label?: string | ReactNode;
  toggleState: boolean;
  readOnly?: boolean;
  name?: string;
}

const ToggleButton: React.FC<ToggleInputProps> = ({
  label,
  variant,
  size,
  className,
  toggleState,
  readOnly,
  onChange,
  name,
  children,
  ...props
}) => {
  return (
    <div className={`flex flex-row`}>
      <label
        className={cn(
          'relative inline-flex items-center',
          readOnly ? 'cursor-not-allowed' : 'cursor-pointer'
        )}>
        <input
          type="checkbox"
          value=""
          name={name ?? ''}
          className="sr-only peer"
          checked={toggleState}
          readOnly={readOnly}
          {...(readOnly ? {} : { onChange })}
          {...props}
        />
        <div className={cn(toggleVariants({ variant, size, className }))}>{children}</div>
      </label>

      {label ? (
        <div
          className={`ms-2 text-sm font-medium text-dark-navy-30 flex flex-wrap items-center ${readOnly ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={readOnly ? () => {} : onChange}>
          {label}
        </div>
      ) : null}
    </div>
  );
};

export default ToggleButton;
